import { gql, QueryResult, useQuery } from '@apollo/client'
import type {
  GetCategoriesForProfileCollectionsQuery,
  GetCategoriesForProfileCollectionsQueryVariables,
} from 'apollo-gql'
import inProfileCollectionsCategoriesFragment from 'graphql/fragments/inProfileCollectionsCategoriesFragment'
import { currentMarketIdVar } from 'graphql/reactive'

export const GET_CATEGORIES_FOR_PROFILE_COLLECTIONS = gql`
  query GetCategoriesForProfileCollections($marketId: ID!, $slug: String!) {
    market(id: $marketId) {
      id
      profile(slug: $slug) {
        id
        slug
        ...inProfileCollectionsCategoriesFragment
      }
    }
  }
  ${inProfileCollectionsCategoriesFragment}
`

type UseProfileInCollectionsCategoriesReturn = {
  categories: GetCategoriesForProfileCollectionsQuery['market']['profile']['inProfileCollections'][0]['publicCmsItem']['content'][]
} & Pick<
  QueryResult<
    GetCategoriesForProfileCollectionsQuery,
    GetCategoriesForProfileCollectionsQueryVariables
  >,
  'loading' | 'error'
>

const useProfileInCollectionsCategories = (
  slug: GetCategoriesForProfileCollectionsQueryVariables['slug'],
): UseProfileInCollectionsCategoriesReturn => {
  const marketId = currentMarketIdVar()

  const { loading, data, error } = useQuery<
    GetCategoriesForProfileCollectionsQuery,
    GetCategoriesForProfileCollectionsQueryVariables
  >(GET_CATEGORIES_FOR_PROFILE_COLLECTIONS, {
    variables: { slug, marketId },
    fetchPolicy: 'cache-and-network',
  })

  const inProfileCollections = data?.market?.profile?.inProfileCollections
  const categories = inProfileCollections?.map(
    (collection) => collection.publicCmsItem?.content,
  )

  return { categories, loading, error }
}

export default useProfileInCollectionsCategories
